import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-correspondence',
    templateUrl: './correspondence.component.html',
    styleUrls: ['./correspondence.component.scss'],
    standalone: false
})
export class CorrespondenceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
